import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { PaymentApiService } from '../services/payment-api.service';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})
export class AccountSettingsComponent {
  currentPlan = "";
  currentPlanText = "";
  showMessage = false;
  message = "";
  alertType: number = 1;

  constructor(@Inject(DOCUMENT) private document: Document, private userApiService: UserApiService, private paymentApiService: PaymentApiService, private authService: AuthService) { }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');
    this.getUserSubscriptionPlan();
  }

  getUserSubscriptionPlan() {
    this.userApiService.getUserSubscriptionPlan().subscribe((response: any) => {
      if (response != null && response.plan != null) {
        this.currentPlan = response.plan.charAt(0).toUpperCase() + response.plan.slice(1);

        switch (response.plan) {
          case "starter":
            this.currentPlanText = "Ideal for individuals who wants to try the Rank Ahead";
            break;

          case "basic":
            this.currentPlanText = "Ideal for individuals with a limited number of pages to be indexed";
            break;

          case "pro":
            this.currentPlanText = "Ideal for individuals regularly publishing a high volume of pages";
            break;

          case "enterprise":
            this.currentPlanText = "Ideal for agencies regularly publishing a high volume of pages";
            break;
        }
      }
    });
  }

  manageSubscription() {
    this.paymentApiService.createCustomerPortalLink().subscribe((response: any) => {
      location.href = response;
    }, (error: any) => {
      this.showAlert(0, "An error occured.");
    })
  }

  deleteAccount() {
    this.userApiService.deleteAccount().subscribe(() => {
      this.showAlert(1, "Your accoont has been deleted.");
      this.authService.signOut();
    }, (error: any) => {
      if (error.status == 400 && error.error?.detail != null) {
        this.showAlert(0, error.error.detail);
      }
    });
  }

  showAlert(alertType: number, message: string) {
    this.alertType = alertType;
    this.message = message;
    this.showMessage = true;

    setTimeout(() => {
      this.showMessage = false;
      this.message = "";
    }, 5000);
  }
}
